import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Renders a digest's markdown into the serif reading column.
 * The .digest-body styling is in src/styles/index.css and matches the
 * spec: serif body, 18px / 1.65 line-height, 70ch max width, the brand
 * URGENT-line treatment when an "URGENT" strong-em pattern appears.
 */
export function DigestBody({ markdown }: { markdown: string }) {
  return (
    <article className="digest-body">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{markdown}</ReactMarkdown>
    </article>
  );
}
